export default __webpack_public_path__ + "static/media/boat_dark.dab6a124.png";